import { render } from "./tpl_top_two_bottom_one.vue?vue&type=template&id=38f16f40&scoped=true"
import script from "./tpl_top_two_bottom_one.vue?vue&type=script&lang=js"
export * from "./tpl_top_two_bottom_one.vue?vue&type=script&lang=js"

import "./tpl_top_two_bottom_one.vue?vue&type=style&index=0&id=38f16f40&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f16f40"],['__file',"src/views/wap/template/tpl_top_two_bottom_one.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38f16f40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38f16f40', __exports__)) {
    console.log('reload')
    api.reload('38f16f40', __exports__)
  }
  
  module.hot.accept("./tpl_top_two_bottom_one.vue?vue&type=template&id=38f16f40&scoped=true", () => {
    console.log('re-render')
    api.rerender('38f16f40', render)
  })

}


export default __exports__